import "./App.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"; //icons
import "primeflex/primeflex.css"; //flex
import "ag-grid-community/styles/ag-theme-quartz.css"; //ag theme 
import "ag-grid-community/styles/ag-theme-material.css"; //ag theme 
import "ag-grid-community/styles/ag-theme-alpine.css"; //ag theme 
import '@websential/cosmic-v20/build/index.css';

import { AppRouter } from "./navigation";
import CssBaseline from "@mui/material/CssBaseline";
import { DefaultSimplePayTheme } from "./themes/DefaultSimplePayTheme";
import { IAppState } from "./store/reducers";
import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { ThemeCssVariables } from "./themes/ThemeCssVariables";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";

// Prime REact Configeration add import files here
//theme


//core











// classname of parent div aggridreact
// ag-theme-quartz
// ag-theme-quartz-dark

// ag-theme-material
// ag-theme-material-dark


// this imports all css from cosmic-v20



// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

const App = () => {
	const isAuthenticated = useSelector(
		(state: IAppState) => state.user.isAuthenticated
	);
	return (
		<>
			<ThemeProvider theme={DefaultSimplePayTheme}>
				<CssBaseline />
				<ThemeCssVariables />
				<AppRouter isAuthenticated={isAuthenticated} />
			</ThemeProvider>
		</>
	);
};

export default App;
